// eslint-disable-next-line import/prefer-default-export, camelcase
export const mainSettings = {
  operator_review: {
    operator_banner: true,
  },
  payment_reviews: {
    operator_banner: false,
  },
  default: {
    operator_banner: false,
    autocomplete: true,
    recommendedCasinos: true,
    topSearches: true,
  },
  article: {
    reading_time: {
      "spielhallen.com": true,
      "demo-rocket-theme.gigmedia.com": true,
      default: false,
    },
  },
};